// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPaginationSmallRight = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16">
            <polygon
                fill="currentColor"
                points="114.655 28 115.291 28.802 120.51 35.383 121 36 120.51 36.617 114.655 44 113 42.766 113.636 41.963 118.366 36 113.636 30.037 113 29.234"
                transform="translate(-113 -28)"
            />
        </svg>
    );
};

export default React.memo(IconPaginationSmallRight);
